import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_IMPORTANT_NOTICES_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetImportantNoticesPayload, ImportantNotices } from '../types/getImportantNotices.types';

export const IMPORTANT_NOTICES_TAGS = 'getImportantNotices';

export const getImportantNotices = (builder: BuilderType) =>
  builder.query<ImportantNotices[], GetImportantNoticesPayload>({
    providesTags: [IMPORTANT_NOTICES_TAGS],
    query: (data) => ({
      data,
      method: 'POST',
      url: GET_IMPORTANT_NOTICES_URL,
    }),
    transformResponse: (response: GenericApiResponse<ImportantNotices[]>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
